import {Button} from "../../__snowpack__/pkg/antd.js";
import React from "../../__snowpack__/pkg/react.js";
import {useState} from "../../__snowpack__/pkg/react.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import {Tooltip} from "../../__snowpack__/pkg/antd.js";
import BorderArrow from "../assets/border_arrow.png";
const Wrapper = styled.div`
  width: 100%;
  height: 47px;
  margin-top: 16px;
  border-radius: 4px;
  position: relative;
  .arrow-alert-tit {
    display: inline-block;
    max-width: 800px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .arrow-alert-box {
    position: absolute;
    left: -556px;
    width: 1000px;
    height: 40px;
    top: 7px;
    line-height: 40px;
    border: 1px solid #6020ff;
    padding-left: 16px;
    font-size: 13px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #202d40;
    border-radius: 4px;
    background: #f1f5ff;
    .arrow-alert-arrow {
      position: absolute;
      right: 200px;
      top: -13px;
      width: 21px;
      height: 13px;
    }
  }
  .arrow-alert-btn-box {
    float: right;
    padding-right: 16px;
  }
`;
export const ArrowAlert = (props) => {
  const {title, formatMessage} = props;
  const [isShow, setIsShow] = useState(true);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("div", {
    className: "arrow-alert-box"
  }, /* @__PURE__ */ React.createElement(Tooltip, {
    placement: "top",
    title
  }, /* @__PURE__ */ React.createElement("span", {
    className: "arrow-alert-tit"
  }, title)), /* @__PURE__ */ React.createElement("img", {
    src: BorderArrow,
    className: "arrow-alert-arrow"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "arrow-alert-btn-box"
  }, /* @__PURE__ */ React.createElement(Button, {
    size: "small",
    type: "ghost",
    style: {marginRight: 16},
    onClick: () => {
      props?.onClose();
    }
  }, formatMessage({id: "cancel"})), /* @__PURE__ */ React.createElement(Button, {
    size: "small",
    type: "primary",
    onClick: () => {
      props?.onOk();
    }
  }, formatMessage({id: "confirm"}))))));
};
